import React, { useState, useEffect } from 'react';

function Admin() {
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    fetchCandidates();
  }, []);

  const fetchCandidates = async () => {
    try {
      const response = await fetch('http://localhost:5001/api/candidates');
      const data = await response.json();
      setCandidates(data);
    } catch (error) {
      console.error('Error fetching candidates:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这个候选人吗？')) {
      try {
        const response = await fetch(`http://localhost:5001/api/candidates/${id}`, {
          method: 'DELETE',
        });
        if (response.ok) {
          fetchCandidates(); // 重新加载候选人列表
        } else {
          alert('删除失败');
        }
      } catch (error) {
        console.error('Error deleting candidate:', error);
        alert('删除失败');
      }
    }
  };

  return (
    <div className="min-h-screen bg-white p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-pink-500">管理</h1>
          <a href="/" className="btn btn-ghost text-pink-500">
            返回主頁
          </a>
        </div>
        
        <div className="overflow-x-auto">
          <table className="table w-full">
            <thead>
              <tr>
                <th>ID</th>
                <th>照片</th>
                <th>名称</th>
                <th>类别</th>
                <th>分数</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {candidates.map((candidate) => (
                <tr key={candidate.id} className="hover">
                  <td>{candidate.id}</td>
                  <td>
                    <div className="avatar">
                      <div className="w-24 rounded">
                        <img
                          src={`http://localhost:5001${candidate.photo_url}`}
                          alt={candidate.name}
                        />
                      </div>
                    </div>
                  </td>
                  <td>{candidate.name}</td>
                  <td>{candidate.category === 'flower' ? '校花' : '校草'}</td>
                  <td>{Math.round(candidate.score)}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(candidate.id)}
                      className="btn btn-error btn-sm"
                    >
                      添加
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Admin;
